module.exports = __webpack_public_path__ + "img/45.65610275.svg";